// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore 
import React, { Suspense } from 'react';

// project imports
import Spinner from 'src/views/spinner/Spinner';

// ===========================|| LOADABLE - LAZY LOADING ||=========================== //

const Loadable = (Component: any) => (props: any) =>
(
  <Suspense fallback={
    <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
      <Spinner sx={{ maxWidth: '50px', maxHeight: '50px' }} />
    </div>}>
    <Component {...props} />
  </Suspense>
);

export default Loadable;
